import axios from '../../config/Axios/axios-instance';
import { Dispatch } from 'redux';
import {
  setSelectedRoleSuccess,
  setSelectedRoleStart,
  setSelectedRoleFail,
  sendPhoneVerificationCodeFail,
  sendPhoneVerificationCodeStart,
  sendPhoneVerificationCodeSuccess,
  confirmPhoneNumberFail,
  confirmPhoneNumberStart,
  confirmPhoneNumberSuccess,
  sendEmailVerificationStart,
  sendEmailVerificationSuccess,
  sendEmailVerificationFail,
  confirmEmailStart,
  confirmEmailSuccess,
  confirmEmailFail,
} from './actions';
import { IntlShape } from 'react-intl';
import { showToast } from '../../utility/toast/toast';
import { translate } from '../../utility/messageTranslator/translate';
import { Roles } from '../../domain/Role';

const API_URL = '/profile';

export type SetSelectedRoleRequest = {
  selectedRole: Roles;
};

export type ConfirmPhoneNumberRequest = {
  code: string;
};

export type ConfirmEmailRequest = {
  code: string;
};

export const setSelectedRole =
  (inputs: SetSelectedRoleRequest, intl: IntlShape) => (dispatch: Dispatch) => {
    dispatch(setSelectedRoleStart());
    return axios
      .patch(`${API_URL}/select-role`, { ...inputs })
      .then(() => {
        dispatch(setSelectedRoleSuccess());
      })
      .catch((err) => {
        dispatch(setSelectedRoleFail(err?.response?.data?.message));
        showToast(translate(intl, err?.response?.data?.message), 'error');
      });
  };

export const sendPhoneVerificationCode =
  (intl: IntlShape) => (dispatch: Dispatch) => {
    dispatch(sendPhoneVerificationCodeStart());
    return axios
      .post(`${API_URL}/phone-verification-code`)
      .then(() => {
        dispatch(sendPhoneVerificationCodeSuccess());
      })
      .catch((err) => {
        dispatch(sendPhoneVerificationCodeFail(err?.response?.data?.message));
        showToast(translate(intl, err?.response?.data?.message), 'error');
      });
  };

export const confirmPhoneNumber =
  (inputs: ConfirmPhoneNumberRequest, intl: IntlShape) =>
  (dispatch: Dispatch) => {
    dispatch(confirmPhoneNumberStart());
    return axios
      .post(`${API_URL}/phone-confirm`, { ...inputs })
      .then(() => {
        dispatch(confirmPhoneNumberSuccess());
      })
      .catch((err) => {
        dispatch(confirmPhoneNumberFail(err?.response?.data?.message));
        showToast(translate(intl, err?.response?.data?.message), 'error');
      });
  };

export const sendEmailVerification =
  (intl: IntlShape) => (dispatch: Dispatch) => {
    dispatch(sendEmailVerificationStart());
    return axios
      .post(`${API_URL}/email-verification`)
      .then(() => {
        dispatch(sendEmailVerificationSuccess());
      })
      .catch((err) => {
        dispatch(sendEmailVerificationFail(err?.response?.data?.message));
        showToast(translate(intl, err?.response?.data?.message), 'error');
      });
  };

export const confirmEmail =
  (inputs: ConfirmEmailRequest, intl: IntlShape) => (dispatch: Dispatch) => {
    dispatch(confirmEmailStart());
    return axios
      .post(`${API_URL}/email-confirm`, { ...inputs })
      .then(() => {
        dispatch(confirmEmailSuccess());
      })
      .catch((err) => {
        dispatch(confirmEmailFail(err?.response?.data?.message));
        showToast(translate(intl, err?.response?.data?.message), 'error');
      });
  };
